var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.09622,
    cy: 9.08743,
    r: 2.4263,
    fill: "var(--green)",
    stroke: "var(--green)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.30158 4.97463C2.21741 4.51171 1.74353 3.97534 1.50732 3.57622C1.326 3.26985 1.12119 2.95439 1.00879 2.61719",
    stroke: "var(--green)",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 4.97463C16.0843 4.51171 16.5582 3.97534 16.7944 3.57622C16.9758 3.26985 17.1806 2.95439 17.293 2.61719",
    stroke: "var(--green)",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17273 3.1293C9.17273 2.64444 9.09668 2.16354 9.09668 1.68442C9.09668 1.45848 9.17273 1.24275 9.17273 1",
    stroke: "var(--green)",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 14C16.0843 14.4629 16.5582 14.9993 16.7944 15.3984C16.9758 15.7048 17.1806 16.0202 17.293 16.3574",
    stroke: "var(--green)",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29279 14C2.20862 14.4629 1.73474 14.9993 1.49853 15.3984C1.31721 15.7048 1.1124 16.0202 1 16.3574",
    stroke: "var(--green)",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83606 15.7857C8.83606 16.2706 8.91211 16.7515 8.91211 17.2306C8.91211 17.4566 8.83606 17.6723 8.83606 17.915",
    stroke: "var(--green)",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00879 9.49119C1.68276 8.00845 4.24386 5.04297 9.09646 5.04297C13.9491 5.04297 16.2406 8.00845 16.7797 9.49119",
    stroke: "var(--green)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7793 9.08694C16.1053 10.5697 13.5442 13.5352 8.69163 13.5352C3.83903 13.5352 1.54752 10.5697 1.00835 9.08694",
    stroke: "var(--green)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.b46d41ce7e61642c1deaf3e43566c1a4.svg";
export { ForwardRef as ReactComponent };